var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoonliteLogoBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1082 195.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3e4347;}.cls-2{fill:#ffe8a6;}.cls-3{fill:#464d51;}.cls-4{fill:#f4dc9f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99,7.36c-28.98,0-52.48,41.46-52.48,92.6s23.49,92.6,52.48,92.6c51.14,0,92.6-41.46,92.6-92.6S150.14,7.36,99,7.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.52,99.96c0-51.14,23.49-92.6,52.48-92.6C47.86,7.36,6.39,48.82,6.39,99.96s41.46,92.6,92.6,92.6c-28.98,0-52.48-41.46-52.48-92.6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 154.56,
    cy: 109.99,
    r: 21.61,
    transform: "translate(4.5 226.04) rotate(-73.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74.79,127.89c-.41,0-.81,.04-1.21,.06,.7-1.95,1.1-4.04,1.1-6.23,0-10.23-8.29-18.52-18.52-18.52-3.49,0-6.73,.98-9.52,2.65,.43,12.03,2.15,23.44,4.94,33.79,.15,.04,.3,.08,.45,.12-.1,.15-.21,.28-.31,.43,5.15,18.82,13.81,34.09,24.47,43.19,14.69-.73,26.39-12.84,26.39-27.71,0-15.34-12.44-27.78-27.78-27.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74.3,66.77c6.82,0,12.34-5.53,12.34-12.35,0-1.99-.52-3.84-1.35-5.51,1.56,.53,3.19,.88,4.93,.88,8.53,0,15.44-6.91,15.44-15.43s-6.91-15.44-15.44-15.44-15.44,6.91-15.44,15.44c0,2.97,.88,5.71,2.33,8.07-.91-.21-1.85-.36-2.82-.36-6.82,0-12.35,5.53-12.35,12.35,0,6.82,5.53,12.35,12.35,12.35Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 114.43,
    cy: 57.51,
    r: 12.35,
    transform: "translate(26.23 150.37) rotate(-73.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M48.42,75.31c-.71,4.54-1.23,9.22-1.54,14.01,1.91-2.17,3.1-4.99,3.1-8.11,0-2.15-.6-4.14-1.56-5.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 120.6,
    cy: 29.73,
    r: 6.17,
    transform: "translate(46.98 129.78) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 160.74,
    cy: 155.67,
    r: 6.17,
    transform: "translate(-34.84 264.4) rotate(-73.15)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 77.39,
    cy: 93.55,
    r: 9.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 142.22,
    cy: 163.62,
    r: 12.35,
    transform: "translate(-63.38 232.4) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.64,105.85c-5.39,3.24-9,9.13-9,15.87,0,8.65,5.93,15.88,13.95,17.93-2.79-10.35-4.51-21.76-4.94-33.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.72,140.19c-2.97,4.42-4.71,9.75-4.71,15.48,0,15.34,12.43,27.78,27.78,27.78,.47,0,.94-.05,1.4-.07-10.66-9.1-19.32-24.37-24.47-43.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.64,93.55c3.7,0,6.98-1.66,9.24-4.24,.31-4.79,.83-9.47,1.54-14.01-2.1-3.82-6.11-6.45-10.78-6.45-6.82,0-12.35,5.53-12.35,12.34s5.53,12.35,12.35,12.35Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 25.29,
    cy: 121.72,
    r: 6.17,
    transform: "translate(-98.98 118.36) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 46.52,
    cy: 49.8,
    r: 6.17,
    transform: "translate(-20.3 63.19) rotate(-58.28)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M289.05,32.72l24.57,94.06,24.47-94.06h34.3V162.78h-26.35v-35.19l2.41-54.22-25.99,89.42h-17.87l-25.99-89.42,2.41,54.22v35.19h-26.26V32.72h34.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.03,109.45c0,17.45-4.12,31-12.37,40.64-8.25,9.65-19.7,14.47-34.35,14.47s-26.05-4.78-34.39-14.34c-8.34-9.56-12.57-22.94-12.68-40.15v-22.24c0-17.87,4.14-31.81,12.42-41.85,8.28-10.03,19.77-15.05,34.48-15.05s25.87,4.93,34.21,14.78c8.34,9.86,12.56,23.69,12.68,41.49v22.24Zm-26.35-21.8c0-11.73-1.67-20.46-5-26.17-3.34-5.72-8.52-8.58-15.54-8.58s-12.12,2.76-15.45,8.26c-3.34,5.51-5.06,13.89-5.18,25.15v23.14c0,11.38,1.7,19.76,5.09,25.15,3.39,5.39,8.63,8.08,15.72,8.08s11.94-2.64,15.27-7.91c3.33-5.27,5.03-13.44,5.09-24.52v-22.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.44,109.45c0,17.45-4.12,31-12.37,40.64-8.25,9.65-19.7,14.47-34.35,14.47s-26.05-4.78-34.39-14.34c-8.34-9.56-12.57-22.94-12.68-40.15v-22.24c0-17.87,4.14-31.81,12.42-41.85,8.28-10.03,19.77-15.05,34.48-15.05s25.87,4.93,34.21,14.78c8.34,9.86,12.56,23.69,12.68,41.49v22.24Zm-26.35-21.8c0-11.73-1.67-20.46-5-26.17-3.34-5.72-8.52-8.58-15.54-8.58s-12.12,2.76-15.45,8.26c-3.34,5.51-5.06,13.89-5.18,25.15v23.14c0,11.38,1.7,19.76,5.09,25.15,3.39,5.39,8.63,8.08,15.72,8.08s11.94-2.64,15.27-7.91c3.33-5.27,5.03-13.44,5.09-24.52v-22.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.22,162.78h-26.26l-38.41-85.31v85.31h-26.26V32.72h26.26l38.5,85.4V32.72h26.17V162.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.49,153.31h53.6v9.47h-63.87V32.72h10.27v120.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.13,162.78h-10.18V32.72h10.18V162.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.14,42.37h-36.98v120.41h-10.27V42.37h-36.89v-9.65h84.14v9.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.7,100.52h-50.47v52.79h58.06v9.47h-68.25V32.72h67.8v9.65h-57.62v48.68h50.47v9.47Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonliteLogoBlack);
export default __webpack_public_path__ + "static/media/moonlite-logo-black.af0c2754f4695a1c798cda260eb2949f.svg";
export { ForwardRef as ReactComponent };